import { LogentriesEnvironment } from "@dffedb/util";
import { EforsyningEnvironment } from "@e-forsyning/common/environment";

export const environment: EforsyningEnvironment & LogentriesEnvironment = {
    logentries: {
        application: "E|Forsyning",
        token: "4d58bcc5-455e-4bc1-a7dc-260cf2a8f01a"
    },
    production: true,
    matomoUrl: "https://matomo.eforsyning.dk/",
    pushApiUrl: "https://pushapi.eforsyning.dk"
};
